import { JsonApiIdentifier, Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

type RedemptionIdentifier = JsonApiIdentifier<'users'> & {
    meta?: {
        createdAt?: string | null;
    };
};

export class Coupon extends Model<Schemas['coupons'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get expiresAtDate() {
        return nullableDate(this.expiresAt);
    }

    get redeemedAtDate() {
        return nullableDate(this.redeemedAt);
    }

    get redemptionEntries() {
        const identifiers = (this.relationships.redemptions?.data || []) as RedemptionIdentifier[];

        const entries = identifiers.map((identifier) => ({
            user: this.store.find(identifier) as Models['users'] | null,
            createdAt: nullableDate(identifier.meta?.createdAt ?? null),
        }));

        if (this.redeemedBy || this.redeemedAtDate) {
            const hasSingleUseEntry = entries.some(
                (entry) =>
                    entry.user?.id === this.redeemedBy?.id &&
                    entry.createdAt?.toISOString() === this.redeemedAtDate?.toISOString(),
            );

            if (!hasSingleUseEntry) {
                entries.unshift({
                    user: this.redeemedBy || null,
                    createdAt: this.redeemedAtDate,
                });
            }
        }

        return entries;
    }
}
